module.exports = __webpack_public_path__ + "static/media/store3.3f7fe242.jpg";